import React, { useState } from "react";
import axios from "axios";

import { Fade } from "react-reveal";

import { InputText } from 'primereact/inputtext';
import { LOGIN_STATES } from "../../data/Login/LoginStates";
import LoginHelper from "../../data/Login/LoginHelper";

export default function PasswordRecoveryForm(props) {
    const [email, setEmail] = useState(props.email);
    const [verifyEmail, setVerifyEmail] = useState(props.verifyEmail);
    const [emailSent, setEmailSent] = useState(props.emailSent);
    const [errorSending, setErrorSending] = useState(props.forgotPasswordError);
    const [errorSendingMessage, setErrorSendingMessage] = useState(props.forgotPasswordErrorMessage);

    const handleRecover = (event) => {
        event.preventDefault();
        axios.post('/api/send-recovery-email', {
            data: {
                email: email,
            },
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            withCredentials: true,
        }).then((res) => {
            if (res.data.status) {
                setEmailSent(true);
            } else {
                setErrorSending(true);
                setErrorSendingMessage(res.data.message);
            }
        })
    }

    const renderRecoverButton = () => {
        if (LoginHelper.verifyEmail(email)) {
            return <button className="login-button approved-button" onClick={handleRecover}>Recover Password</button>
        } else {
            return <button className="login-button denied-button" disabled>Recover Password</button>
        }
    }

    const renderErrorMessage = () => {
        if (errorSending) {
            return (
                <Fade bottom>
                    <li>
                        <h3 className="error-text">{errorSendingMessage}</h3>
                    </li>
                </Fade>
            )
        }
    }

    if (!emailSent) {
        return (
            <>
                <div className="login-box">
                    <h1 className="header">Recover Password</h1>
                    <form>
                        <label>
                            Email: {LoginHelper.verifyEmail() ? <i class="fa-solid fa-check green-check"></i> : <i class="fa-thin fa-asterisk red-asterisk" />}
                            <InputText value={email} onChange={(event) => {
                                setEmail(event.target.value);
                                props.updateReducerState('forgotEmail', event.target.value);

                            }} />
                        </label>

                        <label>
                            Verify Email: {LoginHelper.verifyEmail(verifyEmail) ? <i class="fa-solid fa-check green-check"></i> : <i class="fa-thin fa-asterisk red-asterisk" />}
                            <InputText value={verifyEmail} onChange={(event) => {
                                setVerifyEmail(event.target.value)
                                props.updateReducerState('verifyForgotEmail', event.target.value);
                            }
                            } />
                        </label>
                        <div>
                            {renderErrorMessage()}
                        </div>

                        <div className="login-buttons">
                            <div>
                                {renderRecoverButton()}
                            </div>

                            <div>
                                <button className="login-button all-button" onClick={() => props.setLoginState(LOGIN_STATES.LOGIN)}>Return to Login</button>
                            </div>
                        </div>
                        <p>Don't Have an Account?</p>
                        <button className="login-toggle-button all-button"
                            type="button"
                            onClick={() => props.setLoginState(LOGIN_STATES.SIGNUP)}>
                            Signup <i class="fa-solid fa-right-to-bracket"></i>
                        </button>
                    </form>
                </div>
            </>
        )
    }

    return (
        <>
            <div className="login-box">
                <h2>Recover Password</h2>
                <h3>Your Recovery Request has Been Sent</h3>
                <p>To continue the recovery process, please click the link below.</p>
                <form action="/recover">
                    <button className="approved-button" action="submit">Click here to Continue</button>
                </form>

            </div>
        </>
    )

};